export enum EZConvertFormat {
  TT = "TT",
  NFLX_TT = "NFLX_TT",
  EBU_TT = "EBU_TT",
  SMPTE_TT = "SMPTE_TT",
  EBU = "EBU",
  ITT = "ITT",
  SRT = "SRT",
  VTT = "VTT",
  CAP = "CAP",
  DVD_IMAGES = "DVD_IMAGES",
  PAC = "PAC",
  SCC = "SCC",
  _ASINPUT = "_ASINPUT",
  VTRON = "VTRON",
  _UNKNOWN = "_UNKNOWN",
}
